import React from "react";
import "./FootForget.css";
export default function FootForgot() {
  return (
    <footer className="text-center">
      <div className="container">
        <span>
          © Copyrights {new Date().getFullYear()} all rights reserved by Casper
          Cash
        </span>
      </div>
    </footer>
  );
}
